var Services = require('services/services');
var DataTypes = require('data/datatypes');

var UpdateFailReason = require('../../../topics/topics').UpdateFailReason;

module.exports = function UniversalUpdater(internal) {
    var SET_SERVICE = internal.getServiceLocator().obtain(Services.UPDATE_TOPIC_SET);

    function dataToBytes(d) {
        return d.$buffer.slice(d.$offset, d.$length);
    }

    this.update = function(topic, content, callback) {
        var datatype = DataTypes.get(content);

        if (!datatype) {
            callback(UpdateFailReason.INCOMPATIBLE_UPDATE);
            return;
        }

        var value = datatype.from(content);

        SET_SERVICE.send({
            path : topic,
            bytes : dataToBytes(value)
        }, callback);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/features/topic-control/universal-updater.js
// module id = 995
// module chunks = 1